import React, { useEffect } from 'react';

import { useAuth } from 'hooks/useAuth';

import { PursuitOnboarding } from 'components/layout/PursuitOnboarding';
import { PursuitMember } from 'components/layout/PursuitMember';
import { Loader } from 'components/ui/Loader';

export interface AppScrollProps {
    appScrollToTop: () => void;
}

export const PursuitContainer = ({ appScrollToTop }: AppScrollProps) => {
    const { userProfile } = useAuth();
    const parsedRawData = JSON.parse(
        JSON.stringify(userProfile?.raw_data ?? {})
    );

    useEffect(() => {
        if (parsedRawData?.has_completed_pursuit_onboarding) {
            appScrollToTop();
        }
    }, [appScrollToTop, parsedRawData?.has_completed_pursuit_onboarding]);

    return userProfile == null ? (
        <Loader />
    ) : parsedRawData?.has_completed_pursuit_onboarding ||
      (userProfile?.member_groups?.length ?? 0) > 0 ? (
        <PursuitMember />
    ) : (
        <PursuitOnboarding appScrollToTop={appScrollToTop} />
    );
};
